export const getters = {
  getSelectedClusters: (state) => state.selectedClusters || [],
};
